import ApiClient from "@common/api/ApiClient";

class ComplianceClient extends ApiClient {
  constructor() {
    super("Compliance");
    this.setApiUrlKey("comp_api_url");
  }

  getMetaData = async () => {
    const response = await this.get("Search");
    const {
      status,
      selfExclusionTypes,
      eventTypes,
      incidentTypes,
      periods,
      processedQuarters,
    } = response;

    const selectedPeriod = periods[0]?.value;
    const selectedQuarter = processedQuarters[0]?.id;
    const selectedEventType = [...eventTypes.map((type) => type.id)];
    const selectedIncidentType = [...incidentTypes.map((type) => type.id)];
    const selectedStatuses = [...status.map((status) => status.id)];
    const selectedSelfExclusionType = [
      ...selfExclusionTypes.map((status) => status.id),
    ];

    return {
      ...response,
      selectedPeriod,
      selectedQuarter,
      selectedEventType,
      selectedIncidentType,
      selectedStatuses,
      selectedSelfExclusionType,
    };
  };

  getEventDetails = async (filters) => {
    const {
      allNames,
      ids,
      startDate,
      endDate,
      selectedStatuses,
      selectedEventType,
      selectedIncidentType,
      selectedSelfExclusionType,
      activePage,
      customerIds,
      returnCsv,
      siteIds,
    } = filters;

    const dates = {
      eventDateFrom: `${startDate}T00:00:00`,
      eventDateTo: `${endDate}T23:59:59`,
    };

    const payload = {
      ...(startDate && endDate ? dates : {}),
      allNames,
      siteIds,
      statusIds: selectedStatuses,
      eventTypeIds: selectedEventType.filter((x) => x !== 3 && x !== 5),
      incidentTypeIds: selectedIncidentType,
      selfExclusionTypeIds: selectedSelfExclusionType,
      ids,
      customerIds,
      pageNumber: activePage,
      pageSize: 25,
      returnCsv,
    };

    return returnCsv
      ? this.getFile("Search", "POST", payload)
      : this.post("Search", payload);
  };

  Process = async (id) => await this.get(`Process?organisationUnitId=${id}`);

  Delete = async (id) => await this.post(`Delete?id=${id}`, { id });

  Complete = async (quarter, year, organisationUnitId) =>
    await this.post("Process", { year, quarter, organisationUnitId });

  SiteSummary = async (
    quarter,
    year,
    organisationUnitId,
    returnCsv = false,
  ) => {
    const payload = {
      year,
      quarter,
      organisationUnitId,
      returnCsv,
    };

    return returnCsv
      ? await this.getFile("SiteSummary", "POST", payload)
      : await this.post("SiteSummary", payload);
  };

  ReadForAuthorise = async (id) => {
    const { record } = await this.get(`Update?id=${id}`);
    return record;
  };

  Authorise = async (id, rowVersion, dateTime, comments) => {
    return await this.post(`Authorise`, {
      id,
      rowVersion,
      comments,
      dateTime,
      isAuthorised: true,
    });
  };

  Search = async (request) => {
    return await this.post("Search", request);
  };
}

const client = new ComplianceClient();

export default client;
